<template>
  <div class="red_top_bg">
    <div class="back_left" @click="handleBack">
      <img :src="require('@/assets/back_b.png')">
    </div>
    <div class="big_tit">
      {{ title }}
    </div>
    <p class="top_right" @click="right_router">
      <slot />
    </p>
  </div>
</template>

<script>
export default {
  name: "BsHeader",
  props: {
    backurl: {
      type: [String, Number],
      default: -1
    },
    title: {
      type: [String],
      default: ""
    },
    routerurl: {
      type: [String],
      default: ""
    },
  },
  methods: {
    handleBack(e) {
      // 1. 触发父组件自定义事件
      this.$emit('backurl');

      // 2. 优先判断外部传入的指定跳转路径
      if (this.backurl != -1) {
        this.$router.push({ path: this.backurl });
        return;
      }

      // 3. 使用 Vue Router 官方的 back() 方法，它会自动处理历史记录栈的问题
      // 注意：try...catch 是防止在 SPA 无上一级历史时（如直接刷新页面）报错导致页面卡死
      try {
        this.$router.back();
      } catch (e) {
        // 4. 兜底方案：如果找不到上一页，强制跳转到首页 (index)
        // 这能完美解决 点击没反应 或者 卡在空白页 的问题
        console.warn("无法返回上一页，已自动跳转至首页");
        this.$router.replace({ path: "/" });
      }
    },
    right_router(e) {
      if (this.routerurl != -1) {
        this.$router.push({ path: this.routerurl });
        return;
      }
    }
  },
}
</script>

<style lang="less" scoped>
.red_top_bg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 5px;
  background: #fff;
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 100;
}

.back_left {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px; 
  height: 40px;
  cursor: pointer;
  img {
    height: 20px; 
    width: 20px;
  }
}

.big_tit {
  flex: 1;
  font-size: 18px;
  font-weight: 600;
  color: #000;
  text-align: center;
}

.top_right {
  width: 40px;
  font-size: 14px;
  color: #333;
  text-align: center;
  cursor: pointer;
}
</style>